import $ from 'jquery';
import mediumZoom from 'medium-zoom';
import 'hc-sticky';
import { modalAlertTemplate } from '../templates';
import { Modal } from 'bootstrap';

// eslint-disable-next-line no-undef
const object = gralObject;

$('.product-single-template .entry-header__thumbnail').hcSticky({
    top: 130,
});

mediumZoom('[data-zoomable]');

let modal, modalInstance;

$('.gral-print-button').on('click', function () {
    const button = $(this);
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        xhrFields: {
            responseType: 'blob',
        },
        data: {
            id: button.attr('data-id') * 1,
            nonce: object.nonce,
            action: 'gral_get_product_pdf',
        },
        beforeSend: () => {
            modal = modalAlertTemplate({
                body: object.pdfPending,
                classes: 'gral-pdf-modal',
            });
            $('body').append(modal);

            modalInstance = new Modal($('.gral-pdf-modal')[0]);
            modalInstance.show();
        },
        success: (data) => {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = button.attr('data-title') + '.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            modalInstance.hide();
            $(modal).remove();
        },
    });
});

$('.products-autocomplete')
    .autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: object.ajaxUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                    nonce: object.nonce,
                    action: 'gral_get_products',
                    keyword: request.term,
                },
                success: function (res) {
                    response(res.data.data);
                },
            });
        },
        search: function (event) {
            const submenu = $('.submenu-active');
            submenu.each(function () {
                $( this ).find('ul').animate( {width: 'toggle'}, 200, function () {
                    submenu.removeClass('submenu-active');
                });
            })
            $(event.target)
                .parents('.filter__search')
                .find('button[type=submit]')
                .hide();
            $(event.target)
                .parents('.filter__search')
                .find('.gral-loader')
                .show();
        },
        open: function (event) {
            $(document.body).css('height', '100vh');
            $(document.body).css('overflow', 'hidden');
            $(event.target)
                .parents('.filter__search')
                .find('button[type=submit]')
                .show();
            $(event.target)
                .parents('.filter__search')
                .find('.gral-loader')
                .hide();
            $(event.target).addClass('autocomplete-active');
        },
        close: function (event) {
            $(document.body).css('height', 'unset');
            $(document.body).css('overflow', 'unset');
            $(event.target).removeClass('autocomplete-active');
        },
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append(
                        `<a href="${item.url}" class="res-product">${
                            item.thumbnail
                                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                                : ''
                        }${item.title}</a>`
                    )
                    .appendTo(ul);
            };
        },
    })
    .focus(function () {
        $(this).data('uiAutocomplete').search($(this).val());
    });

$('.product-single-template__highlighted-field').on('click', function () {
    $('.product-single-template__highlighted-field').toggleClass(
        'product-single-template__highlighted-field--active'
    );
});
